const tree = (array) => {
    var treeData = [];
    var treeMaps = {};
    var treeSize = array.length;

    for (let i = 0; i < treeSize; i++) {
        treeMaps[array[i]["id"]] = array[i];
    }
    for (let i = 0; i < treeSize; i++) {
        var node = treeMaps[array[i]["pid"]];
        if (node) {
            if(node.hasOwnProperty('children') === false) {
                node["children"] = [];
            }
            node["children"].push(array[i]);
        } else {
            if(array[i].pid == 0) {
                treeData.push(array[i]);
            }
        }
    }
    sortTree(treeData);

    return treeData;
};

const supvTree = (array) => {
    var treeData = [];
    var treeMaps = {};
    var treeSize = array.length;

    for (let i = 0; i < treeSize; i++) {
        treeMaps[array[i]["id"]] = array[i];
    }
    for (let i = 0; i < treeSize; i++) {
        var node = treeMaps[array[i]["pid"]];
        if (node) {
            if(node.hasOwnProperty('children') === false) {
                node["children"] = [];
            }
            node["children"].push(array[i]);
        } else {
            if(array[i].pid == 0) {
                treeData.push(array[i]);
            }
        }
    }
    sortSupvTree(treeData);

    return treeData;
};

const fileTree = (array) => {
    var treeData = [];
    var treeMaps = {};
    var treeSize = array.length;
    for (let i = 0; i < treeSize; i++) {
        treeMaps[array[i]["id"]] = array[i];
    }
    for (let i = 0; i < treeSize; i++) {
        var node = treeMaps[array[i]["pid"]];
        if (node) {
            if(node.hasOwnProperty('children') === false) {
                node["children"] = [];
            }
            node["children"].push(array[i]);

        } else {
            treeData.push(array[i]);
        }
    }

    sortTree(treeData);

    return treeData;
};

function sortSupvTree(tree) {

    tree.sort(function(a ,b) {
        if(a.sortNum > b.sortNum) {
            return 1;
        } else if(a.sortNum < b.sortNum) {
            return -1;
        }
        return 0;
    });

    tree.forEach(d => {
        if(d.children) {
            sortSupvTree(d.children);
        }
    });
}

function sortTree(tree) {

    tree.sort(function(a ,b) {
        if(a.orderNum > b.orderNum) {
            return 1;
        } else if(a.orderNum < b.orderNum) {
            return -1;
        }
        return 0;
    });

    tree.forEach(d => {
        if(d.children) {
            sortTree(d.children);
        }
    });
}

const columns = (headers) => {
    const result = headers.map(column => {
        if(column.type) {
            return Object.assign({ }, column);
        }
        return Object.assign({ }, column, { width: column.width || column.label.length * 35});
    });

    let size = 0;

    result.forEach((column) => {
        if(!column.type) {
            column.x = size + column.width;
            size += column.width;
        }
    });

    return { columns: result, size };
}


const getKeywords = (hash) => {
    const key = hash || window.location.hash;
    const keywords = window.sessionStorage.getItem('keywords');
    const temp = JSON.parse(keywords || '{}')[key] || {};
    const json = {};
    for(var i in temp) {
        if(i !== 'v') {
            json[i] = temp[i];
        }
    }

    return json;
}

const setKeywords = (item, hash) => {
    const key = hash || window.location.hash;
    const keywords = JSON.parse(window.sessionStorage.getItem('keywords') || '{}');

    const data = Object.assign(keywords, {
        [key]: item
    });

    window.sessionStorage.setItem('keywords', JSON.stringify(data));
}

const removeKeywords = (key) => {
    const keywords = JSON.parse(window.sessionStorage.getItem('keywords') || '{}');

    const data = Object.assign(keywords, {
        [key]: {}
    });

    window.sessionStorage.setItem('keywords', JSON.stringify(data));
}


const getStoreTree = (hash) => {
    const key = hash || window.location.hash;
    const keywords = window.sessionStorage.getItem('store-tree');
    const temp = JSON.parse(keywords || '{}')[key] || {};
    const json = {};
    for(var i in temp) {
        if(i !== 'v') {
            json[i] = temp[i];
        }
    }

    return json;
}

const setStoreTree = (item, hash) => {
    const key = hash || window.location.hash;
    const keywords = JSON.parse(window.sessionStorage.getItem('store-tree') || '{}');

    const data = Object.assign(keywords, {
        [key]: item
    });

    window.sessionStorage.setItem('store-tree', JSON.stringify(data));
}

const getRoles = () => {
    let roles = null;

    return (type) => {
        if(!roles) {
            const string = window.sessionStorage.getItem('session');
            const session = JSON.parse(string) || {};
            roles = session.operation || {};
        }

        return {
            name: "***",
            enabled: true,
            show: true
        };
        // return roles[type] || {
        //     name: "XXX",
        //     enabled: true,
        //     show: true
        // };
    }
}

export default {
    tree,
    supvTree,
    fileTree,
    columns,
    getKeywords,
    setKeywords,
    removeKeywords,
    getStoreTree,
    setStoreTree,
    getRoles
}